const staticPixels = "<script>window.googleTagManagerActive = true; window.dataLayer = window.dataLayer || []; window.gtag = function() { dataLayer.push(arguments); };</script>\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-QZFXRYX7Y9&l=dataLayer\"></script>";

export { staticPixels };